
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';

import utility from '../common/utility';

@Component({})
export default class extends Vue {
    @Prop() public month: any;
    @Prop() public year: any;

    public monthName = '';

    public prevDisabled = false;
    public nextDisabled = true;

    public now = new Date();

    public created() {
        this.setMonthYear(new Date(this.year, this.month - 1, 1, 0, 0, 0, 0));
    }

    public setMonthYear(d: Date) {
        const month = d.getMonth() + 1;

        this.monthName = utility.getMonth(month);

        this.$emit('changeMonthYear', {
            month,
            year: d.getFullYear()
        });
    }

    public btnClick(dir: string) {
        const currMonthFirstDate = new Date(this.now.getFullYear(), this.now.getMonth(), 1);
        const reportMonthFirstDate = new Date(this.year, this.month - 1, 1);

        if ( dir === 'next' ) {
            if ( reportMonthFirstDate.getTime() < currMonthFirstDate.getTime() ) {
                this.setMonthYear(new Date(this.year, this.month, 1));

                // check for next arrow button disable check
                reportMonthFirstDate.setMonth(this.month);
                this.nextDisabled = ( reportMonthFirstDate.getTime() > currMonthFirstDate.getTime() );
            } else {
                this.nextDisabled = true;
            }
        } else {
            this.nextDisabled = this.prevDisabled = false;
            this.setMonthYear(new Date(this.year, this.month - 2, 1));
        }
    }

    @Watch('$route', { immediate: true, deep: true })
    private onUrlChange(newVal: any) {
        this.prevDisabled = this.nextDisabled =  ( newVal.path.split('/').pop() === 'preview-meeting-data' );
    }
}
